import { createCoreMethod } from '../../utils/createCoreMethod';

export const getFromLocalStorage = createCoreMethod(
  'getFromLocalStorage',
  async (key: string) => {
    return await figma.clientStorage.getAsync(key);
  }
);
